import { ValidateFields } from "../../../modules/form/ValidateFields";
import { servicesService } from "../../services/servicesService";
import { getUserData } from "../interfaces/UserInterface";
import { ContactForm } from "./ContactForm";
/**
 * @description Class responsible for handling the form submission.
 */
class ServicesForm {
    // Constructor where the form state is initialized and methods are bound to the correct context
    constructor(formState) {
        this.formState = formState;
        this.formName = '';
        this.ID = 0;
        // Bind methods to the correct context (this)
        this.submitForm = this.submitForm.bind(this);
        this.setServiceForm = this.setServiceForm.bind(this);
    }
    /**
     * Method responsible for submitting the form with the gathered information.
     */
    submitForm() {
        // Select the form using the provided ID
        var _a, _b, _c;
        this.formName = this.formState.manageState('formName');
        this.form = document.querySelector(this.formName);
        let validateForm = new ValidateFields(this.formState);
        let readyToSendForm = validateForm.validateSubmitForm(this.form, 'Servicios');
        if (readyToSendForm) {
            const buttonSend = this.form.querySelector('.btn-form');
            buttonSend.disabled = true;
            (_a = this.form.querySelector('.value-service')) === null || _a === void 0 ? void 0 : _a.classList.add("d-none");
            (_b = this.form.querySelector('#sending-mss-service')) === null || _b === void 0 ? void 0 : _b.classList.remove("d-none");
            (_c = this.form.querySelector('#sending-mss-service')) === null || _c === void 0 ? void 0 : _c.classList.add("d-flex");
            // Get form data
            const sendFormUser = new ContactForm(this.formState);
            sendFormUser.loadSendForm(this.form);
            let userData = getUserData() || sendFormUser.setUserForm(this.form);
            let preregistroData = this.setServiceForm(this.form);
            let formData = { ...userData, ...preregistroData };
            // Instantiate the service to send the form data
            const sendForm = new servicesService(this.formState);
            sendForm.sendLead(formData);
        }
    }
    setServiceForm(form) {
        var _a, _b, _c, _d;
        // Return an object with the extracted form data and context information
        return {
            cargo: (_a = form.querySelector('[name="cargo"]')) === null || _a === void 0 ? void 0 : _a.value,
            company: (_b = form.querySelector('[name="company"]')) === null || _b === void 0 ? void 0 : _b.value,
            sector: (_c = form.querySelector('[name="sector"]')) === null || _c === void 0 ? void 0 : _c.value,
            service: (_d = form.querySelector('[name="service"]')) === null || _d === void 0 ? void 0 : _d.value,
        };
    }
}
// Exporting the class for use in other modules
export { ServicesForm };
